var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (bodyText, buttonText, isAdvancedSearchUsageTooltip, learnMoreLinkText, learnMoreLinkUrl, premiumFeature, premiumSuggestionContent, undefined, works) {
buf.push("<div class=\"DesignSystem\">");
if (premiumSuggestionContent)
{
buf.push("<div class=\"u-p1x\"><div class=\"u-mb8x u-fs20 u-fw700\">" + (jade.escape(null == (jade_interp = `${works.length} Related Paper${works.length > 1 ? 's' : ''}`) ? "" : jade_interp)) + "</div>");
// iterate works
;(function(){
  var $$obj = works;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var work = $$obj[$index];

const coauthors = work.ordered_authors.map((author) => author.display_name || author.name);
buf.push("<div class=\"u-mv6x\"><div class=\"u-mb2x u-fs16 u-lineHeight1_5 text-serif\"><a" + (jade.attr("href", work.url, true, true)) + " class=\"text-gray-darker\">" + (jade.escape(null == (jade_interp = work.title) ? "" : jade_interp)) + "</a></div>");
if (coauthors.length)
{
buf.push("<div class=\"u-tcGrayDark u-fs14 u-lineHeight1_5\">" + (jade.escape(null == (jade_interp = "by\u00A0") ? "" : jade_interp)) + "<span class=\"u-commaList\">");
// iterate coauthors
;(function(){
  var $$obj = coauthors;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var name = $$obj[$index];

buf.push("<li>" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var name = $$obj[$index];

buf.push("<li>" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</li>");
    }

  }
}).call(this);

buf.push("</span></div>");
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var work = $$obj[$index];

const coauthors = work.ordered_authors.map((author) => author.display_name || author.name);
buf.push("<div class=\"u-mv6x\"><div class=\"u-mb2x u-fs16 u-lineHeight1_5 text-serif\"><a" + (jade.attr("href", work.url, true, true)) + " class=\"text-gray-darker\">" + (jade.escape(null == (jade_interp = work.title) ? "" : jade_interp)) + "</a></div>");
if (coauthors.length)
{
buf.push("<div class=\"u-tcGrayDark u-fs14 u-lineHeight1_5\">" + (jade.escape(null == (jade_interp = "by\u00A0") ? "" : jade_interp)) + "<span class=\"u-commaList\">");
// iterate coauthors
;(function(){
  var $$obj = coauthors;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var name = $$obj[$index];

buf.push("<li>" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var name = $$obj[$index];

buf.push("<li>" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</li>");
    }

  }
}).call(this);

buf.push("</span></div>");
}
buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div>");
}
else if (isAdvancedSearchUsageTooltip)
{
buf.push("<div style=\"width:265px\" class=\"u-p1x u-taLeft\"><div style=\"width: 256px\"><h4 class=\"u-fs16\">Updates to Advanced Search!</h4><p>Advanced Search now supports the following operations:</p><div style=\"border-radius: 3px;\" class=\"u-bgColorGrayLighter u-taLeft u-p1x u-ph2x\"><div class=\"u-pv1x\"><b>+</b>" + (jade.escape(null == (jade_interp = ' acts as an ') ? "" : jade_interp)) + "<b>AND</b>" + (jade.escape(null == (jade_interp = ' operator') ? "" : jade_interp)) + "</div><div class=\"u-pv1x\"><b>-</b>" + (jade.escape(null == (jade_interp = ' acts as a ') ? "" : jade_interp)) + "<b>NOT</b>" + (jade.escape(null == (jade_interp = ' operator') ? "" : jade_interp)) + "</div><div class=\"u-pv1x\"><b>|</b>" + (jade.escape(null == (jade_interp = ' acts as an ') ? "" : jade_interp)) + "<b>OR</b>" + (jade.escape(null == (jade_interp = ' operator') ? "" : jade_interp)) + "</div></div><p class=\"u-mt1x\">And more!</p></div><div class=\"u-taCenter\"><a" + (jade.attr("href", learnMoreLinkUrl, true, true)) + (jade.attr("data-main-header-link-target", 'premium_popover_link_for_'+ premiumFeature, true, true)) + " style=\"height:40px;line-height:40px;font-weight:400;text-transform:none;width:256px;\" class=\"Button Button--blue Button--sm js-advanced-search-usage-tooltip u-fs14\">" + (jade.escape(null == (jade_interp = learnMoreLinkText) ? "" : jade_interp)) + "</a></div><script>(function() {\n  Aedu.Dismissibles.recordShow(\"SearchAdvancedUsageNavbarTooltip\");\n\n  $('.js-advanced-search-usage-tooltip').click(function() {\n    Aedu.Dimissibles.recordClickthrough(\"SearchAdvancedUsageNavbarTooltip\");\n  });\n})();</script></div>");
}
else
{
buf.push("<div style=\"width:330px\" class=\"u-p7x u-taCenter\"><div class=\"u-textUppercase u-tcGrayDark u-letterSpacing0_5\">Academia Premium Feature</div><p id=\"premium-icon-body-html\" class=\"u-mv5x\">" + (jade.escape(null == (jade_interp = bodyText) ? "" : jade_interp)) + "</p><a" + (jade.attr("href", learnMoreLinkUrl, true, true)) + (jade.attr("data-main-header-link-target", 'premium_popover_link_for_'+ premiumFeature, true, true)) + " class=\"Button Button--blue Button--sm\">" + (jade.escape(null == (jade_interp = learnMoreLinkText || (buttonText ? buttonText : "Learn More")) ? "" : jade_interp)) + "</a></div>");
}
buf.push("</div>");}.call(this,"bodyText" in locals_for_with?locals_for_with.bodyText:typeof bodyText!=="undefined"?bodyText:undefined,"buttonText" in locals_for_with?locals_for_with.buttonText:typeof buttonText!=="undefined"?buttonText:undefined,"isAdvancedSearchUsageTooltip" in locals_for_with?locals_for_with.isAdvancedSearchUsageTooltip:typeof isAdvancedSearchUsageTooltip!=="undefined"?isAdvancedSearchUsageTooltip:undefined,"learnMoreLinkText" in locals_for_with?locals_for_with.learnMoreLinkText:typeof learnMoreLinkText!=="undefined"?learnMoreLinkText:undefined,"learnMoreLinkUrl" in locals_for_with?locals_for_with.learnMoreLinkUrl:typeof learnMoreLinkUrl!=="undefined"?learnMoreLinkUrl:undefined,"premiumFeature" in locals_for_with?locals_for_with.premiumFeature:typeof premiumFeature!=="undefined"?premiumFeature:undefined,"premiumSuggestionContent" in locals_for_with?locals_for_with.premiumSuggestionContent:typeof premiumSuggestionContent!=="undefined"?premiumSuggestionContent:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"works" in locals_for_with?locals_for_with.works:typeof works!=="undefined"?works:undefined));;return buf.join("");
}